module.exports = __webpack_public_path__ + "static/img/banner1.2115563.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/phoneJoinUs/banner1.png
// module id = mS7W
// module chunks = 0